import { logBuildInfo } from '$lib/buildInfo';
import { initSharedRuntime } from '$lib/office/initialization';

logBuildInfo('functions.js');

// Shared with the taskpane — runs once no matter which entry point Excel loads first. There is
// no router here, so a failure is only logged rather than navigated to an error page.
void initSharedRuntime().catch((error: unknown) => {
    console.error('Error during shared runtime initialization:', error);
});
